import { LinearProgress, Stack, Typography } from '@mui/material';

import { DeviceTriggerState } from 'src/hooks/usePendingDeviceTriggers';

export default function ResetProgress({ devices }: { devices: DeviceTriggerState[] }) {
    const resetCount = devices.filter((device) => !device.isPending).length;

    return (
        <Stack sx={{ gap: 1 }}>
            <Typography variant="body1" sx={{ color: 'grey.900' }}>
                {resetCount} of {devices.length} reset
            </Typography>
            <LinearProgress
                variant="determinate"
                value={(resetCount / devices.length) * 100}
                color="primary"
                sx={{ height: 4, borderRadius: 2, bgcolor: 'neutral.100' }}
            />
        </Stack>
    );
}
